// frontend-customer/src/utils/isRestaurantOpen.js
import { getVendorLocalTime } from './vendorTime';
export function isRestaurantOpen(scheduleData, country = 'India') {
  if (!scheduleData) return false;

  // 1. Safely Parse Data (Handles stringified JSON)
  let hoursObj = scheduleData;
  if (typeof scheduleData === 'string') {
    try { hoursObj = JSON.parse(scheduleData); } catch (e) { return false; }
  }

  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const vendorNow = getVendorLocalTime(country);

const currentMinutes = vendorNow.hour * 60 + vendorNow.minute;
const todayIdx = days.indexOf(vendorNow.weekday.toLowerCase());
const todayStr = days[todayIdx];
const yesterdayStr = days[(todayIdx + 6) % 7];

  // 2. Legacy Fallback (If data is old {open, close} format)
  if (hoursObj.open && hoursObj.close) {
    const legacyStart = hoursObj.open;
    const legacyEnd = hoursObj.close;
    hoursObj = {};
    days.forEach(d => {
      hoursObj[d] = { isClosed: false, shifts: [{ startTime: legacyStart, endTime: legacyEnd }] };
    });
  }

  const parseTime = (timeStr) => {
    if (!timeStr) return 0;
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (modifier === 'PM' && hours !== 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;
    return hours * 60 + minutes;
  };

  // 3. Check Yesterday's Overnight Shifts (e.g., Friday 10 PM to Saturday 2 AM)
  const yesterdaySchedule = hoursObj[yesterdayStr];
  if (yesterdaySchedule && !yesterdaySchedule.isClosed) {
    for (const shift of yesterdaySchedule.shifts) {
      const startMins = parseTime(shift.startTime);
      const endMins = parseTime(shift.endTime);
      if (endMins <= startMins && currentMinutes <= endMins) {
        return true; // Still open from last night
      }
    }
  }

  // 4. Check Today's Shifts
  const todaySchedule = hoursObj[todayStr];
  if (todaySchedule && !todaySchedule.isClosed) {
    for (const shift of todaySchedule.shifts) {
      const startMins = parseTime(shift.startTime);
      const endMins = parseTime(shift.endTime);
      
      if (endMins <= startMins) { // Overnight shift starting today
        if (currentMinutes >= startMins || currentMinutes <= endMins) return true;
      } else { // Standard shift
        if (currentMinutes >= startMins && currentMinutes <= endMins) return true;
      }
    }
  }

  return false;
}